import InputBase from "./InputBase";
import PropTypes from "prop-types";
import Get from "../../../../lib/model/service/resource/dto/Get";
import {createRef} from "react";
import GF from "../../../../lib/utils/GF";
import DialogBase from "../../../../lib/components/dialogs/DialogBase";
import CM from "../../../model/system/CM";
import ResourceEntity from "../../../../lib/model/resource/ResourceEntity";
import {FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";
import {Delete, Download, Upload, Visibility} from "@mui/icons-material";

class InputUpload extends InputBase {

  constructor(props) {
    super(props);
    this.inputUploadReference = createRef();
    let defaultValue = GF.getValue(this.props.defaultValue, '');
    if (defaultValue instanceof ResourceEntity) {
      this.state.defaultValue = defaultValue;
    } else {
      this.state.defaultValue = new ResourceEntity(defaultValue, defaultValue);
    }
    this.state.grid = '';
  }

  getValue() {
    return this.state.defaultValue;
  }

  onUploadInputChange(e) {
    this.state.defaultValue.setFiles(e.target.files);
    this.state.defaultValue.setResourceId('');
    this.state.defaultValue.setResourceName(e.target.files[0].name);
    this.fireOnChange(e, this.state.defaultValue);
    this.setState(this.state);
  }

  previewImage() {
    let resourceName = this.state.defaultValue.getResourceName();
    let href = this.buildResourceLink(this.state.defaultValue.getResourceId(), resourceName);

    let dialog = <DialogBase title={this.props.labelElement}>
      <img src={href} className='rounded' alt={resourceName}/>
    </DialogBase>;
    CM.get().setMainDialog(dialog);
  }

  onDeleteButtonClick(e) {
    this.state.defaultValue.setOldResourceId(this.state.defaultValue.getResourceId());
    this.state.defaultValue.setResourceId('');
    this.state.defaultValue.setResourceName('');
    this.fireOnChange(e, this.state.defaultValue);
    this.setState(this.state);
  }

  buildResourceLink(resourceId, resourceName) {
    let href;
    if (resourceId === resourceName) {
      href = CM.get().getCampaignUrl() + resourceId;
    } else {
      href = Get.buildResourceLink(resourceId, resourceName, GF.getValue(this.props.dtoProperties, null));
    }
    return href;
  }

  render() {
    let resourceId = this.state.defaultValue.getResourceId();
    let resourceName = this.state.defaultValue.getResourceName();

    let href;
    if (resourceName !== '') {
      href = this.buildResourceLink(resourceId, resourceName);
    }

    let uploadMode = '*';
    if (GF.checkNotNull(this.props.uploadMode)) {
      switch (this.props.uploadMode) {
        case 'only_images':
          uploadMode = 'image/*';
          break;
        default:
          break;
      }
    }

    return <>
      <input onChange={(e) => this.onUploadInputChange(e)}
             ref={this.inputUploadReference} className='hidden' type='file' accept={uploadMode}/>
      <FormControl fullWidth size={this.props.size}>
        <InputLabel htmlFor="file-upload">{this.props.labelElement}</InputLabel>
        <OutlinedInput
          id="file-upload"
          value={resourceName}
          readOnly
          label={this.props.labelElement}
          endAdornment={<InputAdornment position='end'>
            {GF.isImageFile(resourceName) && <IconButton size='small' onClick={(e) => this.previewImage(e)}>
              <Visibility/>
            </IconButton>}
            <IconButton size='small' onClick={(e) => this.onDeleteButtonClick(e)}>
              <Delete/>
            </IconButton>
            {href && <a rel='noreferrer' target='_blank' href={href}><IconButton size='small'>
              <Download/>
            </IconButton></a>}
            <IconButton size='small' onClick={(e) => this.inputUploadReference.current.click(e)}>
              <Upload/>
            </IconButton>
          </InputAdornment>}/>
      </FormControl>
    </>

  }
}

InputUpload.propTypes = {
  className: PropTypes.string,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  labelElement: PropTypes.any,
  helpTextElement: PropTypes.node,
  state: PropTypes.oneOf(['none', 'enable', 'disable', 'error', 'readonly']),
  inputLayout: PropTypes.oneOf(['inline', 'outline', '']),
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  accept: PropTypes.string,
  onDeleteClick: PropTypes.func,
  onViewClick: PropTypes.func,
  dtoProperties: PropTypes.object,
  uploadMode: PropTypes.oneOf(['all', 'only_images', '']),
}
export default InputUpload;
